// Input validation utilities for form boundaries.
// Backend is the authority — these catch obvious mistakes early in the UI.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Tokens are UUIDs (hex + dashes) or hex strings up to 128 chars
const TOKEN_RE = /^[a-f0-9-]{1,128}$/i;

export const MAX_EMAIL_LENGTH = 254;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 128;
export const MAX_TITLE_LENGTH = 200;
export const MAX_DESCRIPTION_LENGTH = 500;
export const MAX_GROUP_NAME_LENGTH = 100;

export function isValidEmail(value) {
    return typeof value === 'string' && value.length <= MAX_EMAIL_LENGTH && EMAIL_RE.test(value);
}

export function validatePassword(value) {
    if (typeof value !== 'string' || value.length < MIN_PASSWORD_LENGTH) {
        return `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
    }
    if (value.length > MAX_PASSWORD_LENGTH) {
        return `Password must be at most ${MAX_PASSWORD_LENGTH} characters.`;
    }
    return null;
}

export function isValidToken(value) {
    return typeof value === 'string' && TOKEN_RE.test(value);
}
